import { requestAPI } from '../data/api'
import getUsers from './users/getUsers'
import getMe from '../getMe'

export default async function assignClientToUser(userId, clientId) {
	await requestAPI('/authentication/assign-client-to-user', 'POST', {
		userId,
		clientId,
	})
	await getUsers()
	await getMe()
}
